import { CareerTrackPage } from './CareerTrackPage';
import { useAgentContext } from './CareerTrackPageContainer.agentContext';

export function CareerTrackPageContainer() {
  useAgentContext();

  return <CareerTrackPage />;
}
